import React from 'react';
import { connect } from 'react-redux';
import { withRouter, Prompt } from 'react-router-dom';
import { Row, Col, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import { Elements } from 'react-stripe-elements';
import _ from "lodash";
import { forEach as _forEach, omit as _omit } from 'lodash';

import EntityStateUpdater from 'component/EntityStateUpdater';

import { changeUploadContext, resetUploadContext } from 'actions/UploadActions';
import { updateFormContext, resetFormContext, formStatusDispatchHelper } from 'actions/FormStatusActions';
import { blockForm, releaseForm } from 'actions/ActiveFormsActions';
import { addNotification } from 'actions/NotificationsActions';
import { generateMetaTags } from 'helpers/metaTags';

import Loader from 'components/layout/Loader';
import Breadcrumb from 'components/layout/Breadcrumb';
import Tabs from 'components/layout/Tabs';
import FabActions from 'components/layout/FabActions';
import FabActionElement from 'components/layout/FabActionElement';

import LeadChangeStageChecker from 'components/modals/LeadChangeStageChecker';

import LeadHeader from 'components/layout/lead/LeadHeader';
import LeadData from 'components/layout/lead/LeadData';
import LeadDocs from 'components/layout/lead/LeadDocs';
import LeadOrder from 'components/layout/lead/LeadOrder';
import LeadItems from 'components/layout/lead/LeadItems';
import LeadComments from 'components/layout/lead/LeadComments';
import LeadTimeline from 'components/layout/lead/LeadTimeline';
import LeadProgress from 'components/layout/lead/LeadProgress';
import LeadActions from 'components/layout/lead/LeadActions';
import LeadInvoiceActions from 'components/layout/lead/LeadInvoiceActions';
import LeadContentCheck from 'components/layout/lead/LeadContentCheck';

import Entity from 'components/Entity';
import Data from 'components/Data';
import DocMeta from 'components/DocMeta';

import { entityMetaMapping } from 'js/constants';
import may from 'js/security';

import ActiveFormsToolbar from 'components/forms/ActiveFormsToolbar';
import FormErrors from 'components/forms/FormErrors';
import LeadBudget from './LeadBudget';
import LeadOrderProof from './LeadOrderProof';
import LeadDeliveryData from './LeadDeliveryData';
import LeadChangeAddressData from './LeadChangeAddressData';
import LeadIframeIntegration from 'components/layout/lead/LeadIframeIntegration';
import { isAnyOrderItemOfType } from 'helpers/order';

class LeadView extends EntityStateUpdater {
  constructor(props) {
    super(props);

    this.state = {
      entity: null,
      entityLoaded: false,
      entityChanged: false,
      moveLead: { show: false },
      key: 1,
      activeFormsInitiated: false,
      hasActionsCo: null,
      isPurchaseOrderCo: null,
      changeStageAuto: true,
    };

    this.entity = new Entity();

    // if we get user data from the outside, we can pass it on to our data entity
    if (props.leadData) {
      this.entity.setData(props.leadData);
    }

    if (props.meta[entityMetaMapping.lead] !== undefined && !props.meta[entityMetaMapping.lead].pending) {
      this.entity.setMeta(props.meta, entityMetaMapping.lead);
    }

    if (this.entity.getDataLoaded() && this.entity.getMetaLoaded()) {
      this.state = {
        ...this.state,
        entityLoaded: true,
        entity: this.entity,
      };
    }

    this.dataRef = React.createRef();
  }

  componentWillMount = () => {
    const { leadId, updateUploadContext, updateFormContext } = this.props;

    /* if (false) {
    } else { */
    updateUploadContext({
      type: 'lead_img',
      leadId,
      uploadLink: `/api/leads/${leadId}/docs.json`,
    });

    updateFormContext(leadId);
    // }
  };

  componentDidUpdate = prevProps => {
    const {
      intl: { messages },
      intl,
      user,
      leadId,
      meta,
      formStatus,
      formStatusLeadWon,
      formStatusLeadLost,
      formStatusLeadDelete,
      formStatusLeadReopen,
      formStatusChangeStage,
      formStatusChangePipeline,
      formStatusChangeTeam,
      formStatusMessage,
      formStatusTextMessage,
      formStatusNote,
      formStatusDocument,
      formStatusPriceNegotiation,
      formStatusFilledQuestionnaireNew,
      activeForms,
      data,
      doNotify,
      doBlockForm,
    } = this.props;
    const { activeFormsInitiated } = this.state;

    if (!prevProps.activeForms.allowEdit && activeForms.allowEdit) {
      if (this.dataRef && this.dataRef.current) {
        this.dataRef.current.fetch();
      }
      this.setState({ entityLoaded: false });
    }

    // lead data was saved and there was no error
    if (prevProps.formStatus.pending && !formStatus.pending && !formStatus.hasError) {
      this.setState(prevState => ({ entityChanged: false, key: prevState.key + 1 }));
      doNotify(1, messages.lead_saved);
    }

    // user has marked the lead won! yeah
    if (prevProps.formStatusLeadWon.pending && !formStatusLeadWon.pending && !formStatusLeadWon.hasError) {
      // we load the data again so that the entity will update
      this.updateEntityMultiple(
        ['isWon', 'wonReason', 'closeDate'],
        [
          formStatusLeadWon.response.is_won,
          formStatusLeadWon.response.won_reason,
          formStatusLeadWon.response.closed_date,
        ],
        [],
        () => {
          this.addTimelineEntry([formStatusLeadWon.response.timeline[0]]);
        },
        false
      );
    }

    // user has marked the lead lost
    if (prevProps.formStatusLeadLost.pending && !formStatusLeadLost.pending && !formStatusLeadLost.hasError) {
      // we load the data again so that the entity will update
      this.updateEntityMultiple(
        ['isLost', 'lostReason', 'closeDate'],
        [
          formStatusLeadLost.response.is_lost,
          formStatusLeadLost.response.lost_reason,
          formStatusLeadLost.response.closed_date,
        ],
        [],
        () => {
          this.addTimelineEntry([formStatusLeadLost.response.timeline[0]]);
        },
        false
      );
    }

    // user has marked the lead deleted
    if (prevProps.formStatusLeadDelete.pending && !formStatusLeadDelete.pending && !formStatusLeadDelete.hasError) {
      // we load the data again so that the entity will update
      this.updateEntityMultiple(
        ['isDeleted', 'deletionReason', 'closeDate'],
        [
          formStatusLeadDelete.response.is_deleted,
          formStatusLeadDelete.response.deletion_reason,
          formStatusLeadDelete.response.closed_date,
        ],
        [],
        () => {
          this.addTimelineEntry([formStatusLeadDelete.response.timeline[0]]);
        },
        false
      );
    }

    // user has reopened the lead
    if (prevProps.formStatusLeadReopen.pending && !formStatusLeadReopen.pending && !formStatusLeadReopen.hasError) {
      // we load the data again so that the entity will update
      this.updateEntityMultiple(
        ['isDeleted', 'isWon', 'isLost', 'reopenReasonReason', 'closeDate'],
        [
          formStatusLeadReopen.response.is_deleted,
          formStatusLeadReopen.response.is_won,
          formStatusLeadReopen.response.is_lost,
          formStatusLeadReopen.response.reopen_reason,
          formStatusLeadReopen.response.closed_date,
        ],
        [],
        () => {
          this.addTimelineEntry([formStatusLeadReopen.response.timeline[0]]);
        },
        false
      );
    }

    // user has changed the stage
    if (prevProps.formStatusChangeStage.pending && !formStatusChangeStage.pending && !formStatusChangeStage.hasError) {
      // we load the data again so that the entity will update
      this.updateEntityMultiple(
        ['currentStage'],
        [formStatusChangeStage.response.current_stage],
        [],
        () => {
          if (formStatusChangeStage.response.timeline[0].type === 'handoverCreated') {
            // if the handover was created, add the latest two timeline entries
            this.addTimelineEntry([
              formStatusChangeStage.response.timeline[1],
              formStatusChangeStage.response.timeline[0],
            ]);
          } else {
            this.addTimelineEntry([formStatusChangeStage.response.timeline[0]]);
          }
        },
        false
      );
    }

    // user has changed the pipeline of this lead
    if (
      prevProps.formStatusChangePipeline.pending &&
      !formStatusChangePipeline.pending &&
      !formStatusChangePipeline.hasError
    ) {
      // we load the data again so that the entity will update
      this.updateEntityMultiple(
        ['pipeline', 'currentStage'],
        [formStatusChangePipeline.response.pipeline, formStatusChangePipeline.response.current_stage],
        [],
        () => {
          this.addTimelineEntry([formStatusChangePipeline.response.timeline[0]]);
        },
        false
      );
    }

    // user requested assigning the lead to another team
    if (prevProps.formStatusChangeTeam.pending && !formStatusChangeTeam.pending && !formStatusChangeTeam.hasError) {
      // we load the data again so that the entity will update
      this.updateEntityMultiple(
        ['assignee'],
        [formStatusChangeTeam.response.assignee],
        [],
        () => {
          this.addTimelineEntry([formStatusChangeTeam.response.timeline[0]]);
        },
        false
      );
    }

    // update the timeline when a message is sent
    if (prevProps.formStatusMessage.pending && !formStatusMessage.pending && !formStatusMessage.hasError) {
      this.addTimelineEntry([
        {
          id: Math.random()
            .toString(36)
            .substr(2, 9),
          cdate: formStatusMessage.response.cdate,
          type: 'messageSent',
          text: messages.message_sent,
          public_creator: {
            name: formStatusMessage.response.creator_name,
            id: formStatusMessage.response.creator_id,
            avatar: formStatusMessage.response.creator_avatar,
          },
          params: [{ name: 'messageId', value: formStatusMessage.response.id }],
          dyn_params: [
            { name: 'messageSubject', value: formStatusMessage.response.subject },
            { name: 'messageContent', value: formStatusMessage.response.content },
          ],
        },
      ]);
    }

    // update the timeline when a text message is sent
    if (prevProps.formStatusTextMessage.pending && !formStatusTextMessage.pending && !formStatusTextMessage.hasError) {
      this.addTimelineEntry([
        {
          id: Math.random()
            .toString(36)
            .substr(2, 9),
          cdate: formStatusTextMessage.response.cdate,
          type: 'textMessageSent',
          text: messages.text_message_sent,
          public_creator: {
            name: user.profile.first_name + ' ' + user.profile.last_name,
            id: user.username,
            avatar: null,
          },
          params: [{ name: 'textMessageId', value: formStatusTextMessage.response.id }],
          dyn_params: [{ name: 'textMessageContent', value: formStatusTextMessage.response.content }],
        },
      ]);
    }

    // update the timeline when a note is saved
    if (prevProps.formStatusNote.pending && !formStatusNote.pending && !formStatusNote.hasError) {
      this.addTimelineEntry([
        {
          id: Math.random()
            .toString(36)
            .substr(2, 9),
          cdate: formStatusNote.response.cdate,
          type: 'noteSaved',
          text: messages.note_saved,
          public_creator: {
            name: user.profile.first_name + ' ' + user.profile.last_name,
            id: user.username,
            avatar: null,
          },
          params: [{ name: 'noteId', value: formStatusNote.response.id }],
          dyn_params: [{ name: 'noteContent', value: formStatusNote.response.content }],
        },
      ]);
    }

    // update the timeline when a document gets uploaded
    if (prevProps.formStatusDocument.pending && !formStatusDocument.pending && !formStatusDocument.hasError) {
      this.addTimelineEntry([
        {
          id: Math.random()
            .toString(36)
            .substr(2, 9),
          cdate: formStatusDocument.response.cdate,
          type: 'docUploaded',
          text: messages.document_uploaded,
          public_creator: {
            name: user.profile.first_name + ' ' + user.profile.last_name,
            id: user.username,
            avatar: null,
          },
          params: [{ name: 'docId', value: formStatusDocument.response.id }],
          dyn_params: [{ name: 'docName', value: formStatusDocument.response.name }],
        },
      ]);
    }

    // update the timeline when a new price negotiation offer is sent
    if (
      prevProps.formStatusPriceNegotiation.pending &&
      !formStatusPriceNegotiation.pending &&
      !formStatusPriceNegotiation.hasError
    ) {
      this.updateEntityMultiple(
        ['priceNegotiation'],
        [formStatusPriceNegotiation.response],
        [],
        () => {
          this.addTimelineEntry([
            {
              id: Math.random()
                .toString(36)
                .substr(2, 9),
              cdate: formStatusPriceNegotiation.response.cdate,
              type: 'priceNegotiation',
              text: messages.new_price_negotiation_message_offer_sent,
              public_creator: {
                name: user.profile.first_name + ' ' + user.profile.last_name,
                id: user.username,
                avatar: null,
              },
            },
          ]);
        },
        false
      );
    }

    // update the timeline when the user send a questionnaire
    if (
      prevProps.formStatusFilledQuestionnaireNew.pending &&
      !formStatusFilledQuestionnaireNew.pending &&
      !formStatusFilledQuestionnaireNew.hasError
    ) {
      this.addTimelineEntry([
        {
          id: Math.random()
            .toString(36)
            .substring(2, 11),
          cdate: formStatusFilledQuestionnaireNew.response.cdate,
          type: 'filledQuestionnaireSaved',
          text: intl.formatMessage(
            { id: 'request_to_fill_out_questionnaire_name_saved' },
            { name: formStatusFilledQuestionnaireNew.response.name }
          ),
          public_creator: {
            name: user.profile.first_name + ' ' + user.profile.last_name,
            id: user.username,
            avatar: null,
          },
          params: [
            { name: 'filledQuestionnaireId', value: formStatusFilledQuestionnaireNew.response.id },
            { name: 'filledQuestionnaireToken', value: formStatusFilledQuestionnaireNew.response.token },
          ],
        },
      ]);
    }

    if (prevProps.data.pending && !data.pending) {
      this.entity.setData(data.data);
      if (this.entity.getMetaLoaded()) {
        this.setState(prevState => ({ entityLoaded: true, entity: this.entity, key: prevState.key + 1 }));
      }

      // we received the lead data
      // now we have to see if we can block the lead editing to ourselves
      if (!activeFormsInitiated && !may('ROLE_ROOT_EMPLOYEE', this.props.user.roles)) {
        this.setState({ activeFormsInitiated: true }, () => doBlockForm(leadId));
      }
    }

    const getMasterCopiesUrl = props => {
      try {
        return props.data.data.orders[0].items[0].master_copies[0];
      } catch (err) {
        return '';
      }
    };

    const masterCopyUrlBefore = getMasterCopiesUrl(prevProps);
    const masterCopyUrlAfter = getMasterCopiesUrl(this.props);
    if ((masterCopyUrlBefore || masterCopyUrlAfter) && masterCopyUrlBefore !== masterCopyUrlAfter) {
      this.entity.setData(data.data);
    }

    if (
      prevProps.meta[entityMetaMapping.lead] !== undefined &&
      !meta[entityMetaMapping.lead].pending &&
      !this.entity.getMetaLoaded()
    ) {
      this.entity.setMeta(meta, entityMetaMapping.lead);
      if (this.entity.getDataLoaded()) {
        this.setState(prevState => ({ entityLoaded: true, entity: this.entity, key: prevState.key + 1 }));
      }
    }

    const stages = this.state.entity?.getPipeline()?.stages;
    const stageIdOfContentCheckFinished = _.find(stages, (stage) =>
      _.some(stage.name, (name) =>
        /* Search in both languages if one does not exist in the data set to be sure. */
        (name.lang === "de" && name.name === "Beendet") ||
        (name.lang === "en" && name.name === "Finished")
      )
    )?.id || null;

    if (
      this.state.entityLoaded && // entity loaded
      this.state.entity?.getPipeline()?.name[0]?.name === 'Content Check' && // pipeline === content check
      this.state.entity?.getCurrentStage?.() !== stageIdOfContentCheckFinished && // stage !== finished
      this.props.allFormStatus?.leadChangeStage?.pending !== true && // stage is not currently being updated
      this.state.changeStageAuto // make sure it doesn't end up in an endless loop
    ) {
      if (this.props.dataId && typeof this.props.dataId === 'object') {
        // Normally there should only be one orderId in the content check... but make sure that all ids are checked
        Object.keys(this.props.dataId?.orderAuthorization).forEach((orderId, index) => {
          if (
            this.state.entity
              ?.getOrders?.()
              [index]?.getId()
              ?.includes(orderId)
          ) {
            // check whether authorization is successful
            if (this.props.dataId?.orderAuthorization[orderId]?.data?.authorization_successful) {
              // set update permission to false for the next render update
              this.setState({ changeStageAuto: false }, () => {
                this.moveLead(stageIdOfContentCheckFinished); // set stage of pipeline to finished
              })
            }
          }
        });
      }
    }
  };

  componentWillUnmount = () => {
    const { leadId, doResetUploadContext, doResetFormContext, doReleaseForm } = this.props;
    // release the block so that other users may work on the lead data
    doReleaseForm(leadId);

    doResetUploadContext();
    doResetFormContext();
  };

  formSubmit = e => {
    e.preventDefault();

    const { leadId, activeForms, onSubmit, user } = this.props;

    if (activeForms.allowEdit || may('ROLE_ROOT_EMPLOYEE', user.roles)) {
      this.setState(
        prevState => ({ entity: prevState.entity.validate(), key: prevState.key + 1 }),
        () => {
          if (this.state.entity.isValid) {
            // ommit embedded data like comments and people that are watching the lead
            const data = _omit(this.state.entity.processedData, ['comments', 'watching', 'timeline', 'pipeline']);
            onSubmit(leadId, data);
          }
        }
      );
    }
  };

  getTabHeaderList = () => {
    const {
      intl: { messages },
      leadDocuments,
      quotes,
      invoices,
      user,
    } = this.props;
    const { entity, entityLoaded, hasActionsCo, isPurchaseOrderCo } = this.state;
    const result = [];
    if (entityLoaded) {
      const idPipeline = entity.getPipeline().getId();
      if (this.state.entity?.getPipeline()?.name[0]?.name !== 'Content Check') {
        result.push(messages.lead);
        result.push(
          <React.Fragment>
            {messages.files}
            {leadDocuments.pending || quotes.pending || invoices.pending ? (
              <i className="fa-fw fa fa-circle-notch fa-spin m-l-10" />
            ) : (
              <React.Fragment>
                {leadDocuments.data.count > 0 || quotes.data.count > 0 || invoices.data.count > 0 ? (
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip>
                        {leadDocuments.data.count > 0 && (
                          <div>
                            {leadDocuments.data.count} {messages.files}
                          </div>
                        )}
                        {quotes.data.count > 0 && (
                          <div>
                            {quotes.data.count} {messages.salesDoc.quotes}
                          </div>
                        )}
                        {invoices.data.count > 0 && (
                          <div>
                            {invoices.data.count} {messages.salesDoc.invoices}
                          </div>
                        )}
                      </Tooltip>
                    }
                  >
                    <div className="inline m-l-10 bg-white b-rad-lg text-master-light p-l-5 p-r-5 hint-text">
                      {leadDocuments.data.count + quotes.data.count + invoices.data.count}
                    </div>
                  </OverlayTrigger>
                ) : (
                  ''
                )}
              </React.Fragment>
            )}
          </React.Fragment>
        );

        if (may('ROLE_ACC_INVOICE', user.roles)) {
          result.push(messages.invoice_actions.tab_title);
        }

        if (entityLoaded && !entity.getOrders().length) {
          result.push(messages.products);
        }

        if (isPurchaseOrderCo && isPurchaseOrderCo !== null) {
          result.push(messages.order);
          result.push(messages.dataproof);
          if (!hasActionsCo && isPurchaseOrderCo !== null) {
            result.push(messages.change_of_address);
            result.push(messages.supplier_order);
          }
        }
      }
      if (this.state.entity?.getPipeline()?.name[0]?.name === 'Content Check') {
        result.push(messages.content_check);
      }
      if(isAnyOrderItemOfType(entity.getOrders()[0] ?? null, 'DOMAIN_HOSTING')) {// && getOrderAuthorizationStatus(entity.getOrders()[0] ?? null, 'aws_domain_hosting')) {
        result.push(messages.aws_iframe_hosting);
      }
    }
    return result;
  };

  getTabContentList = () => {
    const { formStatus, activeForms, appIntl, user } = this.props;
    const { entity, entityLoaded, isPurchaseOrderCo } = this.state;
    const result = [];

    const disabled = formStatus.pending || (!activeForms.allowEdit && !may('ROLE_ROOT_EMPLOYEE', user.roles));
    const sharedProps = { entityLoaded, entity, changeEntity: this.changeEntity, disabled };

    if (entityLoaded) {
      const idPipeline = entity.getPipeline().getId();
      if (this.state.entity?.getPipeline()?.name[0]?.name !== 'Content Check') {
        result.push(<LeadData {...sharedProps} />);
        result.push(<LeadDocs leadEntityLoaded={entityLoaded} leadEntity={entity} disabled={formStatus.pending} />);
        if (may('ROLE_ACC_INVOICE', user.roles)) {
          result.push(<LeadInvoiceActions />);
        }
        if (entityLoaded && !entity.getOrders().length) {
          result.push(<LeadItems {...sharedProps} />);
        }
        if (isPurchaseOrderCo) {
          if (entity.getOrders().length) {
            result.push(<LeadOrder {...sharedProps} appIntl={appIntl} />);
          }
          if (entity.getOrders().length) {
            result.push(<LeadOrderProof {...sharedProps} appIntl={appIntl} />);
          }

          if (entity.getOrders().length) {
            result.push(
              <LeadChangeAddressData {...sharedProps} appIntl={appIntl} orderId={entity.getOrders()[0].getId()} />
            );
          }

          if (entity.getOrders().length) {
            result.push(
              <LeadDeliveryData {...sharedProps} appIntl={appIntl} orderId={entity.getOrders()[0].getId()} orderAuthorizationList={entity?.getOrders?.()[0]?.getAuthorizationList?.()} />
            );
          }
        }
      }
      if (this.state.entity?.getPipeline()?.name[0]?.name === 'Content Check') {
        result.push(<LeadContentCheck {...sharedProps} appIntl={appIntl} />);
      }

      if(isAnyOrderItemOfType(entity.getOrders()[0] ?? null, 'DOMAIN_HOSTING')) {// && getOrderAuthorizationStatus(entity.getOrders()[0] ?? null, 'aws_domain_hosting')) {
        result.push(<LeadIframeIntegration {...sharedProps} />);
      }
    }
    return result;
  };

  getTabKeepMounted = () => {
    const keepMounted = [0, 1];
    return keepMounted;
  };

  // user wants to change lead stage
  moveLead = newStageId => {
    this.setState({
      moveLead: {
        show: true,
        lead: this.props.data.data,
        newStageId,
      },
    });
  };

  abortMoveLead = () => {
    this.setState({
      moveLead: {
        show: false,
      },
    });
  };

  addTimelineEntry = (timelineEntries, notifyMessage = null) => {
    const { doNotify } = this.props;

    const timeline = this.state.entity.getTimeline().slice();
    const callback = notifyMessage
      ? () => {
          doNotify(1, notifyMessage);
        }
      : null;

    for (let i = 0; i < timelineEntries.length; i++) {
      timeline.splice(0, 0, this.state.entity.createValue('timeline', [], { ...timelineEntries[i] }));
    }

    this.updateEntity('timeline', timeline, [], callback, false);
  };

  render() {
    const {
      intl: { messages },
      appIntl,
      leadId,
      formStatus,
      activeForms,
      data,
      inModal,
      user,
    } = this.props;

    const { entityLoaded, entityChanged, entity, hasActionsCo, isPurchaseOrderCo } = this.state;

    let metaTitle = messages.lead;
    if (entityLoaded) {
      metaTitle += ' - ' + entity.getTitle();
    }
    let namePipeline = '';
    if (entityLoaded) {
      const idPipeline = entity.getPipeline().getId();
      namePipeline = entity.getPipeline().getName()[0].name;
      if (isPurchaseOrderCo === null) {
        const pipelines = [
          '5f4c0cd929abcb326b11cf22', // Druckvorlage kontrollieren 1
          '5a78622d3e10a279fb71dc82', // onlineOrder 1
          '5e9da28f82ebb1174651c46f', // Druckauftrag 1
          '5f4c0d0a6dade615044fcfe2', // Manual Reduced VAT Rate Check 1
          '5f4c0d0a6dade615044f0fe2', // Zahlungseingang überwachen 1
          '60910f4a211d371db868fd26', // Zahlungseingang überwachen 1
        ];
        const isPurchaseOrderCo = pipelines.includes(idPipeline);
        this.setState({ isPurchaseOrderCo });
      }

      const entityOrders = entity.getOrders();
      if (entityOrders.length > 0 && entityOrders[0] !== null) {
        let isAuthorized = true;

        const authList = entityOrders[0].getAuthorizationList();
        _forEach(authList, iteratee => {
          if (iteratee?.type === 'manual_data_check') {
            isAuthorized = iteratee.getIsAuthorized();
          }
        });
        if (hasActionsCo === null) {
          this.setState({ hasActionsCo: !isAuthorized && idPipeline === '5f4c0cd929abcb326b11cf22' });
        }
      }
    }

    return (
      <DocMeta tags={generateMetaTags(messages.meta.lead_details, metaTitle)}>
        <div class={inModal ? 'p-b-50' : 'padding-25 sm-padding-10'}>
          <Data ref={this.dataRef} dataName="lead" url={`/api/leads/${leadId}.json`} data={data} />
          <FormErrors formStatus={formStatus} />

          <Prompt
            when={entityChanged}
            message={location => messages.save_data_before_nav_to_pathname.replace('{pathname}', location.pathname)}
          />

          <form method="put" onSubmit={this.formSubmit}>
            {!inModal && (
              <Breadcrumb
                crumbs={[
                  { link: appIntl.urlPrefix + 'account', name: 'Dashboard' },
                  { link: appIntl.urlPrefix + 'account/leads', name: messages.leads },
                  { link: null, name: data.data.title },
                ]}
              />
            )}

            <section class="panel no-padding">
              <div class="lead-details-header">
                {namePipeline === 'User Budget check' ? (
                  <Row>
                    <Col xs={12}>
                      <LeadBudget
                        entity={entity}
                        entityLoaded={entityLoaded}
                        updateEntity={this.updateEntity}
                        inModal={inModal}
                      />
                    </Col>
                  </Row>
                ) : (
                  <Row>
                    <Col xs={12}>
                      <LeadHeader
                        entity={entity}
                        entityLoaded={entityLoaded}
                        updateEntity={this.updateEntity}
                        inModal={inModal}
                      />
                    </Col>
                  </Row>
                )}
                {!inModal && namePipeline !== 'User Budget check' && (
                  <Row>
                    <Col xs={12} xsHidden>
                      <LeadProgress entity={entity} entityLoaded={entityLoaded} moveLead={this.moveLead} />
                    </Col>
                  </Row>
                )}
              </div>
            </section>

            {entityLoaded && namePipeline !== 'User Budget check' && (
              <Row>
                <Col xs={12}>
                  <ActiveFormsToolbar
                    formStatus={formStatus}
                    entityChanged={entityChanged}
                    formType="lead"
                    formId={leadId}
                    fabActions={
                      entityLoaded ? (
                        <FabActions>
                          <LeadActions
                            lead={entity}
                            wrapperComponent={null}
                            listItemComponent={<FabActionElement size="60" />}
                          />
                        </FabActions>
                      ) : null
                    }
                  />
                </Col>
              </Row>
            )}

            {namePipeline !== 'User Budget check' && (
              <Row>
                <Col xs={12}>
                  {inModal ? (
                    <LeadData
                      entityLoaded={entityLoaded}
                      entity={entity}
                      changeEntity={this.changeEntity}
                      disabled={
                        formStatus.pending || (!activeForms.allowEdit && !may('ROLE_ROOT_EMPLOYEE', user.roles))
                      }
                      inModal={inModal}
                    />
                  ) : (
                    <Tabs
                      tabs={this.getTabHeaderList()}
                      tabContent={this.getTabContentList()}
                      keepMounted={this.getTabKeepMounted()}
                    />
                  )}

                  {!entityLoaded && <Loader />}
                </Col>
              </Row>
            )}
          </form>

          <Row>
            <Col {...(inModal ? { xs: 12 } : { xs: 12, md: 6 })}>
              <LeadComments
                entityLoaded={entityLoaded}
                entity={entity}
                changeEntity={this.changeEntity}
                disabled={formStatus.pending}
              />
            </Col>
            <Col {...(inModal ? { xs: 12 } : { xs: 12, md: 6 })}>
              {entityLoaded && <h3>{messages.timeline}</h3>}
              <LeadTimeline entityLoaded={entityLoaded} entity={entity} />
            </Col>
          </Row>

          <div id="lead-change-stage-checker">
            <Elements locale={appIntl.locale} key={appIntl.locale}>
              <LeadChangeStageChecker
                lead={this.state.moveLead.lead}
                newStageId={this.state.moveLead.newStageId}
                show={this.state.moveLead.show}
                close={this.abortMoveLead}
              />
            </Elements>
          </div>
        </div>
      </DocMeta>
    );
  }
}
LeadView.defaultProps = {
  inModal: false,
};

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    data: state.data.lead,
    meta: state.entityMeta,
    user: state.login.user,
    leadDocuments: state.list.leadDocuments,
    quotes: state.list.quotes,
    invoices: state.list.invoices,
    formStatus: state.formStatus.leadEdit,
    activeForms: state.activeForms,
    formStatusLeadWon: state.formStatus.leadWon,
    formStatusLeadLost: state.formStatus.leadLost,
    formStatusLeadDelete: state.formStatus.leadDelete,
    formStatusLeadReopen: state.formStatus.leadReopen,
    formStatusChangeStage: state.formStatus.leadChangeStage,
    formStatusChangePipeline: state.formStatus.leadChangePipeline,
    formStatusChangeTeam: state.formStatus.leadChangeTeam,
    formStatusMessage: state.formStatus.messageNew,
    formStatusTextMessage: state.formStatus.textMessageNew,
    formStatusNote: state.formStatus.noteNew,
    formStatusDocument: state.formStatus.leadDocumentNew,
    formStatusPriceNegotiation: state.formStatus.priceNegotiationEdit,
    formStatusFilledQuestionnaireNew: state.formStatus.filledQuestionnaireNew,
    dataId: state.dataId,
    allFormStatus: state.formStatus
  };
};
const mapDispatchToProps = dispatch => {
  return {
    updateFormContext: id => {
      dispatch(updateFormContext('lead', id));
    },
    doResetFormContext: () => {
      dispatch(resetFormContext());
    },
    updateUploadContext: newContext => {
      dispatch(changeUploadContext(newContext));
    },
    doResetUploadContext: () => {
      dispatch(resetUploadContext());
    },
    doNotify: (code, text) => {
      dispatch(addNotification(code, text));
    },
    onSubmit: (leadId, args) => {
      formStatusDispatchHelper('leadEdit', `/api/leads/${leadId}.json`, args, 'put', dispatch);
    },
    doBlockForm: id => {
      dispatch(blockForm('lead', id));
    },
    doReleaseForm: id => {
      dispatch(releaseForm('lead', id));
    },
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(LeadView)
  )
);
